module.exports = __webpack_public_path__ + "media/images/front/favicon-a646bd851c8d5fc8fd40c5766ef4f13b.ico";